import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ModeContext = createContext();

export const ModeProvider = ({ children }) => {
  const location = useLocation();
  const isArtMode = location.pathname.startsWith('/art');
  const mode = isArtMode ? 'artist' : 'engineer';

  // --- NEW: Global Terminal State ---
  const [isTerminalExpanded, setIsTerminalExpanded] = useState(false);

  useEffect(() => {
    document.body.setAttribute('data-mode', mode);
  }, [mode]);

  return (
    // Add the new state and setter to the context value
    <ModeContext.Provider value={{ 
      mode, 
      isArtMode,
      isTerminalExpanded,     // NEW
      setIsTerminalExpanded   // NEW
    }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = () => useContext(ModeContext);